// src/services/api.js
import axios from "axios";
import { store } from "../redux/store";
import { logout } from "../redux/slices/authSlice";
import { isSessionExpired } from "../utils/sessionTimer";

const API = axios.create({
  baseURL: process.env.REACT_APP_POCAS_BASE_URL || "",
  timeout: 6 * 60 * 1000, // 6 minutes by default for safety
  headers: { Accept: "application/json" },
  withCredentials: false,
});

// Request interceptor: attach token, check expiry using monotonic session timer
API.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (!token) return config;

    if (isSessionExpired()) {
      store.dispatch(logout());
      return Promise.reject({ message: "Authentication token expired", code: "TOKEN_EXPIRED", status: 401 });
    }

    config.headers = { ...config.headers, Authorization: `${token}` };
    return config;
  },
  (error) => Promise.reject(error)
);

// Response normalizer (cancellation aware)
API.interceptors.response.use(
  (resp) => resp,
  (error) => {
    if (error?.name === "CanceledError" || error?.code === "ERR_CANCELED") {
      return Promise.reject({ message: "Request cancelled", code: "CANCELLED", status: 499, name: "CanceledError" });
    }

    let normalized = { message: "An unexpected error occurred", code: "UNKNOWN_ERROR", status: error?.response?.status, details: null };

    if (error?.response?.data) {
      const data = error.response.data;
      normalized.message = data.message || data.error?.message || JSON.stringify(data);
      normalized.code = data.code || normalized.code;
      normalized.details = data;
    } else if (error?.message) {
      normalized.message = error.message;
    }

    return Promise.reject(normalized);
  }
);

export default API;
